import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "../../actions/actionCreators";
import withModal from "./withModal";

// Custom Components
import MaterialModal from "./MaterialModal";

const genericDeleteModalProps = {
    // Injected from Redux
    modalProps: PropTypes.shape({ executeAction: PropTypes.func.isRequired, id: PropTypes.any.isRequired }).isRequired,
    isOpen: PropTypes.bool.isRequired,
    // Injected from Redux (ActionCreators)
    hideModal: PropTypes.func,
};

type GenericDeleteModalProps = PropTypes.InferProps<typeof genericDeleteModalProps>;

const GenericDeleteModal: React.FC<GenericDeleteModalProps> = ({ modalProps, isOpen }: GenericDeleteModalProps) => {
    const dispatch = useDispatch();

    const { executeAction, id } = modalProps;

    const hide = () => dispatch(hideModal("GENERIC_DELETE"));

    const deleteAction = () => {
        executeAction(id);
        hide();
    };

    return (
        <MaterialModal
            title="Delete Item"
            isOpen={isOpen}
            onClose={hide}
            onPrimaryButtonRequest={deleteAction}
            primaryButtonText="Delete"
            id="delete"
            maxWidth="lg"
        >
            <span>
                Are you sure you want to <strong className="text-danger">delete</strong> this item?
                <br />
                <strong className="text-danger">
                    This action is permanent; the item cannot be recovered after deletion.
                </strong>
            </span>
        </MaterialModal>
    );
};

export default withModal(GenericDeleteModal, "GENERIC_DELETE");
